<div  id="pollSlider-button" class="sidebar-outer" *ngIf="global.roledetail=='admin'" >
   
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>